import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { GlobalSettingsService } from '@fi-app/global-settings/global-settings.service';

@Component({
    selector: 'fi-global-settings-navigation-tabs',
    templateUrl: './global-settings-navigation-tabs.component.html',
    styleUrls: ['./global-settings-navigation-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-global-settings-navigation-tabs' },
    standalone: false,
})
export class GlobalSettingsNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private globalSettingsService: GlobalSettingsService,
    ) {
        super(injector);
    }

    public ngOnInit(): void {
        this.tabs = this.globalSettingsService.getGlobalSettingsTabs();
        super.updateSelectedTabFromState(false);
    }
}
